import ProductListingPage from "./ProductListingPage";

export default ProductListingPage;
